import { FORM_TYPE, GeneratedTemplateUploadStatus } from "../../constants/constants";
export default {
  topologies: [],
  machineTasks: {
    machineName: "",
    topologyDetails: {},
    environment: {},
  },
  taskLogs: {
    logs: [],
    show: false,
  },
  propertyBag: {
    bag: {},
    show: false,
    updated: false,
  },
  topologyTypes: [],
  cloudTypesDefaultClassic: [],
  vsRemoteDebuggerPort: "",

  customFormData: {
    show: false,
    partnerId: 1,
    template: {},
    environment: {},
    formType: FORM_TYPE.PRIVATE_TOPOLOGY,
    templateForLookupFileUploaded: GeneratedTemplateUploadStatus.NotStarted,
  },
  queueRequests: [],
  queueRequestsSelected: [],
  duplicateThresholdTopologies: [],
  userRegion: {
    data: null,
    isLoading: false,
    error: null,
    responseBody: null,
  },
};
